import { render } from "./NotFoundView.vue?vue&type=template&id=a5391fc2&scoped=true"
const script = {}

import "./NotFoundView.vue?vue&type=style&index=0&id=a5391fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5391fc2"]])

export default __exports__